/*
 *  ************************************************************************
 *  *  © [2015 - 2020] Quintype Technologies India Private Limited
 *  *  All Rights Reserved.
 *  *************************************************************************
 */
import React, { Suspense, useState } from "react";
import { PropTypes } from "prop-types";
import "./adyen-modal.module.css";

const AdyenModal = ({ afterOpen, afterClose }) => {
  const Modal = React.lazy(() => import("react-modal"));

  const [modalIsOpen, setIsOpen] = useState(true);

  const openModal = () => setIsOpen(true);

  const afterOpenModal = () => afterOpen();

  const parentSelector = () => document.getElementById("adyen-modal");

  const closeModal = () => {
    setIsOpen(false);
    afterClose({ error: "Payment terminated" });
  };

  return (
    <Suspense fallback={<div />}>
      <button onClick={openModal}>Open Modal</button>
      <Modal
        parentSelector={parentSelector}
        isOpen={modalIsOpen}
        onAfterOpen={afterOpenModal}
        onRequestClose={closeModal}
        contentLabel="Adyen Payment"
        shouldCloseOnOverlayClick={false}
        portalClassName="adyenWrapper"
      >
        <div id="dropin-adyen" styleName="adyen" />
      </Modal>
    </Suspense>
  );
};

AdyenModal.propTypes = {
  afterOpen: PropTypes.func,
  afterClose: PropTypes.func
};

export default AdyenModal;
